// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-title button span{
    outline: none !important;
    padding: 1rem;
}
.image-preivew {
    padding-right: 1rem;

    .extra-details {
        .dimension {
            display: grid;

            span {
                font-size: 13px;
                font-weight: 500;

            }
        }
        .cancel-img {
            button {
                border-radius: 50%;
                background-color: red;
                color: white;
                border: 2px solid #fff;
            }
        }

    }

    img {
        height: 100px;
        width: 150px;
    }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb2R1Y3QtbGlzdC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQTtJQUNJLHdCQUF3QjtJQUN4QixhQUFhO0FBQ2pCO0FBQ0E7SUFDSSxtQkFBbUI7O0lBRW5CO1FBQ0k7WUFDSSxhQUFhOztZQUViO2dCQUNJLGVBQWU7Z0JBQ2YsZ0JBQWdCOztZQUVwQjtRQUNKO1FBQ0E7WUFDSTtnQkFDSSxrQkFBa0I7Z0JBQ2xCLHFCQUFxQjtnQkFDckIsWUFBWTtnQkFDWixzQkFBc0I7WUFDMUI7UUFDSjs7SUFFSjs7SUFFQTtRQUNJLGFBQWE7UUFDYixZQUFZO0lBQ2hCO0FBQ0oiLCJmaWxlIjoicHJvZHVjdC1saXN0LmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJcbi5tb2RhbC10aXRsZSBidXR0b24gc3BhbntcbiAgICBvdXRsaW5lOiBub25lICFpbXBvcnRhbnQ7XG4gICAgcGFkZGluZzogMXJlbTtcbn1cbi5pbWFnZS1wcmVpdmV3IHtcbiAgICBwYWRkaW5nLXJpZ2h0OiAxcmVtO1xuXG4gICAgLmV4dHJhLWRldGFpbHMge1xuICAgICAgICAuZGltZW5zaW9uIHtcbiAgICAgICAgICAgIGRpc3BsYXk6IGdyaWQ7XG5cbiAgICAgICAgICAgIHNwYW4ge1xuICAgICAgICAgICAgICAgIGZvbnQtc2l6ZTogMTNweDtcbiAgICAgICAgICAgICAgICBmb250LXdlaWdodDogNTAwO1xuXG4gICAgICAgICAgICB9XG4gICAgICAgIH1cbiAgICAgICAgLmNhbmNlbC1pbWcge1xuICAgICAgICAgICAgYnV0dG9uIHtcbiAgICAgICAgICAgICAgICBib3JkZXItcmFkaXVzOiA1MCU7XG4gICAgICAgICAgICAgICAgYmFja2dyb3VuZC1jb2xvcjogcmVkO1xuICAgICAgICAgICAgICAgIGNvbG9yOiB3aGl0ZTtcbiAgICAgICAgICAgICAgICBib3JkZXI6IDJweCBzb2xpZCAjZmZmO1xuICAgICAgICAgICAgfVxuICAgICAgICB9XG5cbiAgICB9XG5cbiAgICBpbWcge1xuICAgICAgICBoZWlnaHQ6IDEwMHB4O1xuICAgICAgICB3aWR0aDogMTUwcHg7XG4gICAgfVxufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/pages/product-management/product-list/product-list.component.css"],"names":[],"mappings":";AACA;IACI,wBAAwB;IACxB,aAAa;AACjB;AACA;IACI,mBAAmB;;IAEnB;QACI;YACI,aAAa;;YAEb;gBACI,eAAe;gBACf,gBAAgB;;YAEpB;QACJ;QACA;YACI;gBACI,kBAAkB;gBAClB,qBAAqB;gBACrB,YAAY;gBACZ,sBAAsB;YAC1B;QACJ;;IAEJ;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;AACJ;AACA,w1CAAw1C","sourcesContent":["\n.modal-title button span{\n    outline: none !important;\n    padding: 1rem;\n}\n.image-preivew {\n    padding-right: 1rem;\n\n    .extra-details {\n        .dimension {\n            display: grid;\n\n            span {\n                font-size: 13px;\n                font-weight: 500;\n\n            }\n        }\n        .cancel-img {\n            button {\n                border-radius: 50%;\n                background-color: red;\n                color: white;\n                border: 2px solid #fff;\n            }\n        }\n\n    }\n\n    img {\n        height: 100px;\n        width: 150px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
